import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, HeartPulse } from 'lucide-react';
import { analyticsDb } from '../../firebase';

// Dashboard strip: the three fleet numbers + a way into the Fleet health page. Same single document as the
// page (mdm-analitics fleet/summary).

const pct = (v) => (v === null || v === undefined ? '–' : `${v}%`);

function Figure({ label, value, note, tone, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-left rounded-lg px-3 py-2 bg-surface-inset border border-white/[0.06] hover:border-white/[0.18] transition-colors min-w-0"
    >
      <p className="text-[11px] sm:text-xs text-gray-500 truncate">{label}</p>
      <p className="text-lg sm:text-xl font-bold text-white leading-tight">{value}</p>
      {note && <p className={`text-[11px] truncate ${tone === 'danger' ? 'text-red-300' : 'text-gray-500'}`}>{note}</p>}
    </button>
  );
}

export default function FleetHealthStrip({ summary: summaryProp }) {
  const navigate = useNavigate();
  const [live, setLive] = useState(undefined);

  useEffect(() => {
    if (summaryProp) return undefined;
    return onSnapshot(
      doc(analyticsDb, 'fleet', 'summary'),
      (snap) => setLive(snap.exists() ? snap.data() : null),
      () => setLive(null),
    );
  }, [summaryProp]);

  const summary = summaryProp || live;
  if (!summary) return null;
  const k = summary.kpis || {};

  return (
    <section className="card-chrome mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-5">
        <div className="flex items-center gap-3 lg:w-44 shrink-0">
          <div className="brand-icon-badge"><HeartPulse size={16} /></div>
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-white">Fleet health</h3>
            <p className="text-xs text-gray-500">{k.active ?? 0} active devices</p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 sm:gap-3 flex-1">
          <Figure label="Availability" value={pct(k.availabilityNow)} note={`7 days ${pct(k.availability7d)}`} onClick={() => navigate('/health')} />
          <Figure
            label="Problems"
            value={k.problemDevices ?? 0}
            note={`${k.critical ?? 0} critical`}
            tone={k.critical ? 'danger' : undefined}
            onClick={() => navigate('/health')}
          />
          <Figure label="Offline now" value={k.offline ?? 0} note={`of ${k.active ?? 0}`} onClick={() => navigate('/devices?status=offline')} />
        </div>
        <button type="button" onClick={() => navigate('/health')} className="btn-secondary justify-center w-full lg:w-auto shrink-0">
          Open Health <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
}
